var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g({staticClass:"mt-n1 mr-n1",attrs:{"fab":"","x-small":"","dark":"","color":"primary"}},_vm.scope.on),[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-square-edit-outline")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }